/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NonCadastralContractParcelDataPk } from './nonCadastralContractParcelDataPk.model';
import { DnepduosEntity } from './dnepduosEntity.model';


export interface NonCadastralContractParcelData { 
    contractId: number;
    dnepduos1?: DnepduosEntity;
    dnepduos1Acreage?: number;
    dnepduos1Year?: number;
    dnepduos2?: DnepduosEntity;
    dnepduos2Acreage?: number;
    dnepduos2Year?: number;
    dnepduos3?: DnepduosEntity;
    dnepduos3Acreage?: number;
    dnepduos3Year?: number;
    drupozKodMan?: number;
    id?: NonCadastralContractParcelDataPk;
    koeficientMan?: number;
    _new?: boolean;
    osvobozenaVymera?: number;
    parcelId: number;
    parcelRentAveragePrice?: number;
    parcelRentFromAcreage?: number;
    parcelRentParcelPrice?: number;
    priceAddAveragePrice?: number;
    priceAddAveragePricePercent?: number;
    priceAddParcelPrice?: number;
    priceAddParcelPricePercent?: number;
    pronajataVymera?: number;
    taxAdd?: number;
    taxComputed?: number;
    taxFromRentedAcreage?: number;
    taxPayerId?: number;
    taxTenant?: boolean;
    useParcelRent: boolean;
    useTaxFromRentedAcreage?: boolean;
    useTaxReturnDrupozKodOriginal?: boolean;
    zastavenaVymera?: number;
    zpevnenaPlochaX?: number;
    zpevnenaPlochaY?: number;
    zpvypoKodMan?: number;
}

